<div class="loader-backdrop" *ngIf="isLoading">
    <div class="spinner"></div>
</div>
